import { useIntl } from 'react-intl';
import Info from 'src/componentes/info';
import Lookup from 'src/componentes/select2';
import useAuth from 'src/hooks/useAuth';

const RespostaOcorrenciaLookup = ({ ...rest }) => {
  const intl = useIntl();
  const { terms: resources } = useAuth();

  const customStyle = {
    option: (base, state) => ({
      ...base,
      color: '#1e2022',
      backgroundColor: state.isSelected ? '#dae1eb' : 'white',
      padding: '.5rem 3rem .5rem .5rem',
      cursor: state.isDisabled ? 'not-allowed' : 'pointer',
      opacity: state.isDisabled ? 0.6 : 1,
    }),
  };

  const lookupRenderDescricao = ({ data }, isOption) => {
    if (!data) return null;

    if (!isOption) return data?.nome;

    return (
      <div>
        <div className="d-flex align-items-center">
          <span className={data.disabled ? 'text-muted' : 'font-weight-bold'}>
            {data.nome}
          </span>

          {data.hint && data.showHint && (
            <Info
              id={`hint-lookup-${data.id}`}
              placement="top"
              text={intl.formatMessage(
                { id: data.hint },
                { risco: resources.risco }
              )}
            />
          )}
        </div>

        {data.descricao && (
          <div className="overflow-hidden line-clamp-2 text-sm text-muted">
            {data.descricao}
          </div>
        )}
      </div>
    );
  };

  return (
    <Lookup
      labelKey="nome"
      valueKey="id"
      url="/RespostaOcorrenciaLookup"
      valueComponent={lookupRenderDescricao}
      clearable
      customStyle={customStyle}
      isOptionDisabled={(opt) => opt?.disabled}
      {...rest}
    />
  );
};

export default RespostaOcorrenciaLookup;
